import { renderPublicInfoModal } from 'reactApp/ui/PublicInfoModal/PublicInfoModal.helpers';
import { PublicInfoPlace } from 'reactApp/ui/PublicInfoModal/PublicInfoModal.types';

import { getSelectedItemsOrCurrentFolder } from './helpers/getSelectedItemsOrCurrentFolder';

// tempexp_18662-start
export const showPublicInfo = (): void => {
    const items = getSelectedItemsOrCurrentFolder();
    const item = items[0];

    let place = PublicInfoPlace.file;
    if (item.kind === 'album') {
        place = PublicInfoPlace.album;
    } else if (item.isFolder) {
        place = PublicInfoPlace.folder;
    }

    renderPublicInfoModal({
        id: item.id,
        qaId: 'public-info-modal-toolbar',
        place,
    });
};
// tempexp_18662-end
